const ComplianceState = {
    Compliant: 1,
    CompliantWithWarnings: 2,
    NoneCompliant: 3,
    Alarm: 4,
};

export default ComplianceState;



// WEBPACK FOOTER //
// ./src/app/components/transports/ComplianceState.js